import React, { useRef } from "react"
import Barcode from "react-barcode"
import { Button } from "reactstrap"

const InternationalBookingPrint = ({ booking }) => {
  const printRef = useRef()

  const handlePrint = () => {
    window.print()
  }

  return (
    <div className="print-wrapper">
      <div ref={printRef} className="label-container">
        {/* HEADER */}
        <div className="label-header">
          <img src="/logo.png" alt="Company Logo" className="logo" />
          <div className="tracking">
            <div className="title">AIR WAYBILL</div>
            <div className="tracking-id">{booking.tracking_id}</div>
          </div>
        </div>

        {/* ROUTING */}
        <div className="routing">
          <div>
            <b>Carrier:</b> {booking.carrier_name}
          </div>
          <div>
            <b>Destination:</b> {booking.zone_country}
          </div>
        </div>

        {/* SENDER / RECEIVER */}
        <div className="addresses">
          <div className="box">
            <h6>SENDER</h6>
            <p>
              {booking.sender_first_name} {booking.sender_last_name}
              <br />
              {booking.sender_phone}
              <br />
              {booking.sender_address}
            </p>
          </div>

          <div className="box">
            <h6>RECEIVER</h6>
            <p>
              {booking.receiver_first_name} {booking.receiver_last_name}
              <br />
              {booking.receiver_phone}
              <br />
              {booking.receiver_address}
            </p>
          </div>
        </div>

        {/* PARCEL BARCODES */}
        {booking.parcels.map(parcel => (
          <div key={parcel.piece_no} className="barcode-section">
            <div className="piece">
              Piece {parcel.piece_no} of {booking.pieces}
            </div>

            <Barcode
              value={parcel.barcode_value}
              format="CODE128"
              width={2}
              height={80}
              displayValue
            />
          </div>
        ))}

        {/* FOOTER */}
        <div className="footer">
          <div>
            <b>Weight:</b> {booking.weight} kg
          </div>
          <div>
            <b>Date:</b> {new Date(booking.created_at).toLocaleDateString()}
          </div>
        </div>
      </div>

      {/* PRINT BUTTON */}
      <div className="no-print text-center mt-3">
        <Button color="primary" onClick={handlePrint}>
          🖨 Print Label
        </Button>
      </div>

      {/* STYLES */}
      <style>{`
        body {
          background: #f8f9fa;
        }

        .label-container {
          width: 100mm;
          padding: 10mm;
          background: #fff;
          border: 1px solid #000;
          font-family: Arial, sans-serif;
          margin: auto;
        }

        .label-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 2px solid #000;
          padding-bottom: 8px;
        }

        .logo {
          height: 40px;
        }

        .tracking-id {
          font-size: 14px;
          font-weight: bold;
        }

        .routing {
          display: flex;
          justify-content: space-between;
          margin: 8px 0;
          font-size: 12px;
        }

        .addresses {
          display: flex;
          gap: 10px;
          margin-bottom: 10px;
        }

        .box {
          flex: 1;
          border: 1px solid #000;
          padding: 6px;
          font-size: 11px;
        }

        .box h6 {
          margin: 0 0 4px 0;
          font-size: 11px;
          font-weight: bold;
        }

        .barcode-section {
          text-align: center;
          margin-top: 10px;
          border-top: 1px dashed #000;
          padding-top: 8px;
        }

        .piece {
          font-size: 11px;
          margin-bottom: 4px;
        }

        .footer {
          display: flex;
          justify-content: space-between;
          font-size: 11px;
          margin-top: 10px;
          border-top: 2px solid #000;
          padding-top: 6px;
        }

        @media print {
          body * {
            visibility: hidden;
          }
          .label-container,
          .label-container * {
            visibility: visible;
          }
          .label-container {
            position: absolute;
            left: 0;
            top: 0;
          }
          .no-print {
            display: none;
          }
        }
      `}</style>
    </div>
  )
}

export default InternationalBookingPrint
